import { defineStore } from 'pinia';
import { useMainStore } from './mainStore';
import adminAuthService from "../services/admin-auth.service";

export const useAuthAdminStore = defineStore('authAdmin', {
    state: () => {
        const admin = JSON.parse(localStorage.getItem("sportips_auth_admin"));
        let initialState = {
            isLogged: admin ? true : false,
            adminData: admin ? admin : null,
        }
        return initialState;
    },
    actions: {
        async login(login_details) {
            let res = await adminAuthService.login(login_details);
            if (res) {
                this.isLogged = true;
                this.adminData = res;
                localStorage.setItem("sportips_auth_admin", JSON.stringify(res));
            }

        },
        logout() {
            this.isLogged = false;
            this.adminData = null;
            localStorage.removeItem("sportips_auth_admin");
        },
    },
    getters: {
        getUsername: (state) => state.adminData.username,
        getAdminData: (state) => state.isLogged && state.adminData,
        hasVerificateurRights: (state) => state.isLogged && state.adminData.privilege === 'pc_course' || state.adminData.privilege === 'respo_medical' || state.adminData.privilege === 'coordinateur',
        isSportipsAdmin: (state) => state.isLogged && state.adminData.privilege === 'sportips',
        hasAdminRights: (state) => state.isLogged && state.adminData.privilege === 'sportips' || state.adminData.privilege === 'admin',
        hasSuperAdminRights: (state) => state.isLogged && state.adminData.privilege === 'sportips' && (state.adminData.username === 'florian' || state.adminData.username === 'yann'),
        hasModuleAccess: (state) => {
            if (!state.isLogged) return false;
            if (state.adminData.privilege === 'sportips') return true;
            if (!state.adminData.list_modules) return false;
            const mainStore = useMainStore();
            const id_module = mainStore.module.id;
            return state.adminData.list_modules.includes(id_module);
        },

    },
});